import Vue from 'vue'
import ViewUI from 'view-design'

import '@/common/css/iview-variables.less'

Vue.use(ViewUI)
